// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".admin-setup .currencyContainer {\n  max-width: 100%;\n  padding: 0px; }\n", "",{"version":3,"sources":["webpack://./src/home/AdminSetup/Expenditure/Expenditure.scss"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY,EAAA","sourcesContent":[".admin-setup .currencyContainer {\n  max-width: 100%;\n  padding: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
